import { useState, useRef, useEffect } from 'react';
import { formatCurrency } from '../../utils/formatting';

export default function EditableCell({ value, onChange, editable = true }) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState('');
  const inputRef = useRef(null);

  useEffect(() => {
    if (editing && inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, [editing]);

  function handleClick() {
    if (!editable) return;
    setDraft(value?.toString() || '0');
    setEditing(true);
  }

  function commit() {
    const parsed = parseFloat(draft);
    if (!isNaN(parsed)) {
      onChange(parsed);
    }
    setEditing(false);
  }

  function handleKeyDown(e) {
    if (e.key === 'Enter') commit();
    if (e.key === 'Escape') setEditing(false);
  }

  if (editing) {
    return (
      <input
        ref={inputRef}
        type="number"
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onBlur={commit}
        onKeyDown={handleKeyDown}
        className="w-full px-1 py-0.5 text-[12px] text-right border border-bullogic-blue rounded-[2px] outline-none bg-white"
      />
    );
  }

  const isNegative = value < 0;
  return (
    <span
      onClick={handleClick}
      className={`block text-right ${editable ? 'cursor-pointer hover:bg-blue-50' : ''} ${
        isNegative ? 'text-rose' : ''
      }`}
    >
      {formatCurrency(value)}
    </span>
  );
}
